/*
   mapUIState stores and controls state of UI components
 */

export const MAP_STATE_CREATE_SELECT_REGION = {drawings: false, sidebar: false}
export const MAP_STATE_EDIT_SELECT_REGION = {drawings: false, sidebar: false}
export const MAP_STATE_DIALOG = {drawings: false, sidebar: false}
export const MAP_STATE_GEOMETRY_DIALOG_ON_EDIT = {drawings: false, sidebar: false}
export const MAP_STATE_NORMAL = {drawings: true, sidebar: true}

class mapUIState {
    constructor(mapUI) {
        this.mapUI = mapUI;
        this.curState = null;
        this.stateItems = {
            drawings: true,
            sidebar: true,
        }
        this.stateItemsHandlers = {
            drawings: this.tDrawings.bind(this),
            sidebar: this.tSidebar.bind(this)
        }
        this.drawingsButtons = ["drawMarker", "drawPolyline", "drawRectangle", "drawPolygon", "drawCircle", "drawCircleMarker", "importFromFile", "rotateMode", "styleEditor", "editMode", "dragMode", "removalMode"]

        // custom options sent to stateItem with defined MAP_STATE
        this.statesOptions = [
            {
                mapState: MAP_STATE_CREATE_SELECT_REGION,
                item: "drawings",
                // let's leave 'drawRectangle' and 'removalMode' buttons available
                options: this.drawingsButtons.filter( el => (el !== "drawRectangle" && el !== "removalMode"))
            },
            {
                mapState: MAP_STATE_EDIT_SELECT_REGION,
                item: "drawings",
                options: this.drawingsButtons
            },
            {
                mapState: MAP_STATE_GEOMETRY_DIALOG_ON_EDIT,
                item: "drawings",
                options: this.drawingsButtons.filter( el => (el !== "editMode"))
            },
        ]
    }

    toggleMapState(state) {
        for (let s in state) {
            if (this.stateItems[s] !== undefined && (this.stateItems[s] !== state[s] || state !== this.curState)) {
                let options = null
                for (let i in this.statesOptions) {
                    if (this.statesOptions[i].mapState === state && this.statesOptions[i].item === s) {
                        options = this.statesOptions[i].options
                        break
                    }
                }
                this.stateItemsHandlers[s](state[s], options)
                this.stateItems[s] = state[s]
            }
        }
        this.curState = state
    }

    isMapState(state) {
        return this.curState === state
    }

    tDrawings(newState, affectedButtons) {
        let buttons = (affectedButtons) ? affectedButtons : this.drawingsButtons
        for (let i in buttons) {
            this.mapUI.map.pm.Toolbar.setButtonDisabled(buttons[i], !newState)
        }
    }

    tSidebar(newState) {
        let panes = this.mapUI.sidebar._tabitems
        for (let i in panes) {
            let paneId = panes[i]._id
            newState ? this.mapUI.sidebar.enablePanel(paneId) : this.mapUI.sidebar.disablePanel(paneId)
        }
    }
}

export {mapUIState};
